<template>
  <VCard class="elevation-12">
    <VCardTitle class="orange darken-1 white--text">
      <VLayout row wrap justify-center>
        <VFlex xs12 text-xs-center>
          <h2>WCI Shift Lookup</h2>
        </VFlex>
      </VLayout>
    </VCardTitle>

    <VCardText class="pa-4">
      <p class="text-xs-center mb-4">
        Enter your information to view your next shift.
      </p>

      <VForm ref="form" @submit.prevent="handleSubmit">
        <!-- Last 4 digits -->
        <VTextField
          v-model="lastFour"
          label="Last 4 digits of your phone"
          prepend-icon="mdi-dialpad"
          :rules="lastFourRules"
          maxlength="4"
          type="tel"
          inputmode="numeric"
          required
          class="mb-2"
          @keypress="onlyNumbers"
        ></VTextField>

        <!-- Last name -->
        <VTextField
          v-model="lastName"
          label="Last Name"
          prepend-icon="mdi-account"
          :rules="lastNameRules"
          autocapitalize="words"
          required
          class="mb-2"
        ></VTextField>

        <!-- Error message -->
        <VAlert v-if="errorMessage" :value="true" type="error" class="mt-3">
          {{ errorMessage }}
        </VAlert>

        <!-- Submit button -->
        <BaseButton
          type="submit"
          color="orange darken-1"
          block
          large
          class="mt-4"
          :loading="loading"
          :disabled="!isFormValid || loading"
        >
          View My Shift
        </BaseButton>
      </VForm>
    </VCardText>
  </VCard>
</template>

<script>
import { VLayout, VFlex, VTextField } from 'vuetify/lib'
import { VCard, VCardTitle, VCardText } from '@vuetify/VCard'
import VForm from '@vuetify/VForm'
import VAlert from '@vuetify/VAlert'

export default {
  name: 'ShiftVerificationForm',
  components: {
    VLayout,
    VFlex,
    VCard,
    VCardTitle,
    VCardText,
    VTextField,
    VForm,
    VAlert,
  },
  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      lastFour: '',
      lastName: '',
      lastFourRules: [
        (v) => !!v || 'Last 4 digits are required',
        (v) => (v && v.length === 4) || 'Must be exactly 4 digits',
        (v) => /^\d{4}$/.test(v) || 'Must be numbers only',
      ],
      lastNameRules: [
        (v) => !!v || 'Last name is required',
        (v) =>
          (v && v.trim().length >= 2) ||
          'Last name must be at least 2 characters',
      ],
    }
  },
  computed: {
    isFormValid() {
      return (
        this.lastFour.length === 4 &&
        /^\d{4}$/.test(this.lastFour) &&
        this.lastName.trim().length >= 2
      )
    },
  },
  methods: {
    onlyNumbers(event) {
      const char = String.fromCharCode(event.keyCode || event.which)
      if (!/[0-9]/.test(char)) {
        event.preventDefault()
      }
    },
    handleSubmit() {
      if (!this.isFormValid) return

      this.$emit('verify', {
        lastFour: this.lastFour,
        lastName: this.lastName.trim(),
      })
    },
  },
}
</script>

<style scoped>
.v-card__title h2 {
  font-weight: 500;
}
</style>
